// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { LayoutProvider } from "./context/LayoutContext"; // ✨ Make sure this is imported
import { DataProvider } from "./context/DataContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <DataProvider>
        {/* ✨ THE FIX: The LayoutProvider must wrap the Router and App */}
        <LayoutProvider>
          <Router>
            <App />
          </Router>
        </LayoutProvider>
      </DataProvider>
    </AuthProvider>
  </React.StrictMode>
);
